import { Get, Post, urls } from 'assets/js/api';

// keys is a list of user settings keys for which we can inject settings for
// users on a per user basis.
export const Keys = {
  // Constants
  AccountTemplates: 'account_templates',
  CollapsedCategories: 'collapsed_categories',
  DefaultAdminSite: 'default_admin_site',
  FilterGlobals: 'filter_globals',
  HelpBoxes: 'help_boxes',
  HiddenDashboardSites: 'HIDDEN_DASHBOARD_SITES',
  LiveMaps: 'live_maps',
  ProjectSettings: 'site_projects',
  Reservations: 'site_reservations',
  ShowExpandedDashboardReservations: 'show_ex_dashboard_res',
  ShowOldDashboardApprovals: 'show_old_dashboard_approvals',
  ShowApprovedDashboardApprovals: 'show_approved_dashboard_approvals',
  OnlyShowRatesRequiringApproval: 'only_show_rates_requiring_approval',
  DashboardReservationsFutureDays: 'dashboard_reservations_future_days',
  ReleaseNotesHead: 'release_notes_head',
  ShowAdvancedInvoiceItems: 'show_advanced_invoice_items',

  // ID based
  PortalSettings: (id) => `portal_id${id}`,
  SiteSettings: (id) => `site_id${id}`,
  ReservableSettings: (id) => `reservable_id${id}`,
};

// FetchVal fetches a value for some key. If isObject is true, the value
// is assumed to be a JSON object as a string and must be parsed.
export const FetchVal = async (key, isObject) => {
  const resp = await Get(urls.KEYVALUE_GET(key));
  const val = isObject ? JSON.parse(resp.data) : resp.data;
  return val;
};

// StoreVal stores a value for some key. Users can indicate that a value is
// an object that requires JSON encoding by setting the isObject flag, which
// automatically encodes the object.
export const StoreVal = async (key, val, isObject) => {
  const params = {
    key,
    value: isObject ? JSON.stringify(val) : val,
  };
  await Post(urls.KEYVALUE_SET, params);
};
